import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, LoginPage, ProtectedRoute } from '@/features/auth';
import { DashboardPage } from '@/features/dashboard';
import { ReviewListPage } from '@/features/reviews';
import { EventListPage } from '@/features/events';
import { SettingsPage, MailingListPage, EventTextListPage, CancellationTermListPage, PaymentNoteTemplateListPage, RegistrationNoteTemplateListPage, FinancialSupportListPage, EventImportJobsPage } from '@/features/settings';
import { UserListPage } from '@/features/users';
import { Layout } from '@/components/layout/Layout';
import { Toaster } from '@/components/ui/toaster';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviews"
            element={
              <ProtectedRoute>
                <Layout>
                  <ReviewListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <SettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          {/* Eigene Seite statt einer Karte in den Einstellungen: die Liste braucht
              die volle Breite (Mehrfachauswahl, fünf Spalten, ~48 Zeilen). Sie setzt
              deshalb bewusst kein max-w-4xl, anders als SettingsPage. */}
          <Route
            path="/settings/mailings"
            element={
              <ProtectedRoute>
                <Layout>
                  <MailingListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/event-texts"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventTextListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/cancellation-terms"
            element={
              <ProtectedRoute>
                <Layout>
                  <CancellationTermListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/payment-note-templates"
            element={
              <ProtectedRoute>
                <Layout>
                  <PaymentNoteTemplateListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/registration-note-templates"
            element={
              <ProtectedRoute>
                <Layout>
                  <RegistrationNoteTemplateListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/financial-support"
            element={
              <ProtectedRoute>
                <Layout>
                  <FinancialSupportListPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/event-import"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventImportJobsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
